import { QueryKey } from '@tanstack/react-query';
import Switch from 'components/switch/Switch';
import {
  IntegrationStatus,
  InternalIntegrationSetting,
} from 'models/InternalIntegrationSetting';
import useDisableIntegrationMutation, {
  IntegrationMutationLevel,
} from 'pages/integrations/hooks/useDisableIntegrationMutation';
import { INTEGRATIONS_REQUIRING_SHARE_GUEST_INFO } from 'pages/integrations/IntegrationsTabs.constants';
import useShareGuestInfoModal from 'pages/integrations/modals/shareGuestInfoModal/useShareGuestInfoModal';
import { useNavigate } from 'react-router-dom';

const OutboundOAuthSwitch = ({
  integrationSetting,
  queryKey,
}: {
  integrationSetting: InternalIntegrationSetting;
  queryKey: QueryKey;
}) => {
  const navigate = useNavigate();
  const { disableIntegration } = useDisableIntegrationMutation();
  const { openShareGuestInfoModal } = useShareGuestInfoModal();

  const {
    agencySettings: { status },
    enumId,
    integration,
  } = integrationSetting;

  const isActive = status === IntegrationStatus.ACTIVE;

  return (
    <Switch
      data-testid="integration-status-switch"
      className="small"
      checked={isActive}
      onClick={(e) => {
        e.stopPropagation();

        const redirectToIntegrationConnection = () => {
          navigate(`/integrations/connect/${enumId}`);
        };

        if (isActive) {
          disableIntegration({
            level: IntegrationMutationLevel.AGENCY,
            enumId: integration.enumId,
            queryKey,
          });
        } else {
          const needsShareGuestInfo =
            INTEGRATIONS_REQUIRING_SHARE_GUEST_INFO.includes(
              integration.enumId,
            );

          if (needsShareGuestInfo) {
            openShareGuestInfoModal({
              integration,
              onConfirm: () => {
                redirectToIntegrationConnection();
              },
            });

            return;
          }

          redirectToIntegrationConnection();
        }
      }}
    />
  );
};

export default OutboundOAuthSwitch;
